import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import { useRef } from 'react'
import { closeDeleteModal } from 'src/redux/features/admin/adminSlice'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { deleteAdmin } from 'src/view-models/Admin'

const DeleteModal = () => {
    const dispatch = useAppDispatch()
    const toast = useToast()
    const {isOpenDelete,adminId} = useAppSelector((state)=>state.admin)
    const finalRef = useRef(null)

    const handleDelete = async () => {
        const response = await deleteAdmin(adminId!,toast)
        if(response.status === true) {
          handleClose()
          window.location.reload()
        } 
      }

    const handleClose = () => {
        dispatch(closeDeleteModal())
    }

  return (
    <Modal finalFocusRef={finalRef} isOpen={isOpenDelete} onClose={handleClose}>
        <ModalOverlay 
        />
        <ModalContent>
          <ModalHeader>Suprimer Admin</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Êtes-vous sûr de vouloir supprimer <span className='font-bold' ></span> Admin?</Text>
          </ModalBody>
          <ModalFooter >
            <HStack gap={4} >
              <Button colorScheme='red' onClick={handleDelete}>Suprimer</Button>
              <Button colorScheme='blue' mr={3} onClick={handleClose}>
                Fermer
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}

export default DeleteModal